import React from 'react';
import { type BattleUnit } from '@/core/types/battle.types';
import './UnitStatsPortrait.css';
import { UnitPortrait } from './UnitPortrait';
import { useLingui } from '@lingui/react/macro';


export function UnitStatsPortrait({ unit }: {unit: BattleUnit}) {
    const { t, i18n } = useLingui();
    const renderStat = (label: string, current: number | string, isBonus: boolean, rangeMax?: number) => (
        <div className="stat-row">
            <span className="label">{label}</span>
            {/* Додаємо клас bonus-active, якщо є бафф */}
            <span className={`value ${isBonus ? 'bonus-active' : ''}`}>
                {current}{rangeMax !== undefined ? `-${rangeMax}` : ''}
                {isBonus && (
                    <svg className="chevron-icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 7L6 3L10 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        <path d="M2 10L6 6L10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
                    </svg>
                )}
            </span>
        </div>
    );

    return (
        <div className="unit-stats-portrait hide-on-mobile-portrait">
            <UnitPortrait unit={unit} />
            <div className="stats-column">
                <div className="unit-name">{i18n._(unit.unitName)}</div>
                
                {renderStat(t`DAMAGE`, unit.stats.damageMin, false, unit.stats.damageMax)}
                {renderStat(t`ARMOR`, unit.stats.armor, false)}
                {renderStat(t`EVASION`, unit.stats.evasion || 1, false)}
            </div>
        </div>
    );
}